<template></template>

<script>
    export default {
        name: 'set-title',
        props: ['title', 'no-prefix'],
        created () {
            this.setTitle()
        },
        watch: {
            title () {
                this.setTitle()
            }
        },
        methods: {
            setTitle: function(){
                let prefix = this.noPrefix ? '' : 'GTC | '
                document.title = prefix + this.title
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/js/components/fragments/title.vue